<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="支付详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">标题:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">价格:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.price }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">时长:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.duration }}分钟
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">展示次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.totalVisitCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.totalRecordCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">备注:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.text || '无' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">状态:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.step === 1">待发布</el-tag>
          <el-tag v-if="showForm.step === 2" type="success">已发布</el-tag>
          <el-tag v-if="showForm.step === 3" type="danger">已下架</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">创建时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">修改时间:</el-col>
        <el-col :span="19">
          {{ showForm.updated && moment(showForm.updated).format('YYYY-MM-DD HH:mm:ss') || '无' }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { findPayment } from '@/api/alfmeier'
export default {
  name: 'AlfmeierPaymentDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const paymentId = row.paymentId
      this.row = row
      const data = await findPayment({
        paymentId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
